// extracted by mini-css-extract-plugin
export default {"app":"+rmkO","roundedBorders":"ICdwp"};